import React, { Suspense, lazy } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../../../utils/webpack/chunkRetry';

const CommentReduxModule = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "comment_redux2" */
        './CommentReduxModule'
      )
  )
);

export interface Props {}

export const LoadableCommentReduxModule: React.FC<Props> = () => {
  const isMounted = useIsMounted();

  if (!isMounted) {
    return null;
  }

  // prevent inside iframes
  if (typeof window !== 'undefined' && window.top !== window.self) {
    return null;
  }

  return (
    <ErrorBoundary debugComponent="LoadableCommentReduxModule">
      <Suspense fallback={null}>
        <CommentReduxModule />
      </Suspense>
    </ErrorBoundary>
  );
};
LoadableCommentReduxModule.displayName = 'LoadableCommentReduxModule';

export default LoadableCommentReduxModule;
